{
	"language": {
		"aria": "Taal wijzigen"
	},
	"placeholder": {
		"title": "Je kandidatencentrum is onderweg",
		"body": "Er is hier nog niets. Zodra het klaar is, sturen we je een link per e-mail."
	},
	"not_found": {
		"title": "Pagina niet gevonden",
		"body": "Controleer de link die je hebt gevolgd, of gebruik de link uit je e-mail."
	},
	"error_boundary": {
		"reload": "Pagina opnieuw laden"
	},
	"login": {
		"loading": "Laden…",
		"title": "Log in bij je kandidatencentrum",
		"intro": "Vul je e-mailadres in om je reacties te bekijken.",
		"email_label": "E-mailadres",
		"email_placeholder": "jij@voorbeeld.com",
		"submit": "Inloggen",
		"sending": "Verzenden…",
		"sent": {
			"title": "Check je e-mail",
			"body": "Als {{email}} overeenkomt met een reactie, is er een aanmeldlink onderweg.",
			"retry": "Niet ontvangen? Controleer het adres en probeer het opnieuw"
		},
		"resent": {
			"title": "We hebben je een nieuwe aanmeldlink gestuurd",
			"body": "De link die je hebt geopend is verlopen. Als je e-mailadres overeenkomt met een reactie, is er een nieuwe aanmeldlink onderweg. Deze opent dezelfde pagina.",
			"request_manually": "Niet ontvangen? Vraag een nieuwe link aan"
		},
		"request_error": {
			"throttled": "Te veel pogingen. Wacht een minuut en probeer het opnieuw.",
			"invalid_email": "Voer een geldig e-mailadres in.",
			"generic": "Er is iets misgegaan. Probeer het opnieuw."
		},
		"unknown_organisation": {
			"title": "Pagina niet gevonden",
			"body": "Controleer de link die je hebt gevolgd, of gebruik de link uit je e-mail."
		},
		"error": {
			"title": "Er is iets misgegaan",
			"body": "We konden deze pagina niet laden. Probeer het over een moment opnieuw."
		}
	},
	"organisations": {
		"title": "Jouw reacties",
		"intro": "Kies een bedrijf om de reacties te bekijken die je hebt verstuurd.",
		"count_one": "{{count}} reactie",
		"count_other": "{{count}} reacties",
		"empty": {
			"title": "Nog geen reacties",
			"body": "Zodra je op een vacature van een bedrijf reageert, verschijnt dat hier."
		},
		"error": "We konden je bedrijven niet laden. Probeer het over een moment opnieuw.",
		"log_out": "Uitloggen",
		"logging_out": "Uitloggen…"
	},
	"submissions": {
		"title": "Eerdere reacties",
		"back_to_organisations": "Alle bedrijven",
		"cv_uploaded": "Cv geüpload",
		"empty": {
			"title": "Nog geen reacties",
			"body": "Reacties die je naar {{organisation}} stuurt, verschijnen hier."
		},
		"error": "We konden je reacties niet laden. Probeer het over een moment opnieuw.",
		"log_out": "Uitloggen",
		"logging_out": "Uitloggen…"
	},
	"profile": {
		"link": {
			"title": "Mijn profiel",
			"cv_added": "Cv toegevoegd",
			"cv_missing": "Nog geen cv"
		},
		"back": "Terug naar overzicht",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Je hebt toestemming gegeven om benaderd te worden over deze functie.",
		"cv": {
			"title": "Cv",
			"upload": {
				"title": "Upload je cv",
				"drop_hint": "of sleep je bestand hierheen",
				"constraints": "{{types}} · Max. {{size}} MB",
				"uploading": "{{fileName}} uploaden…",
				"done": "Cv geüpload",
				"error_type": "Dit bestandstype wordt niet ondersteund. Toegestane typen: {{types}}.",
				"error_size": "Dit bestand is te groot. De maximale grootte is {{size}} MB."
			},
			"remove": {
				"label": "{{fileName}} verwijderen",
				"question": "{{fileName}} verwijderen?",
				"consequence": "De werkgever kan het bestand dan niet meer zien. Dit kan niet ongedaan worden gemaakt.",
				"confirm": "Cv verwijderen",
				"cancel": "Annuleren",
				"removing": "Verwijderen…",
				"error": "Je cv kon niet worden verwijderd. Probeer het opnieuw."
			}
		},
		"work_history": {
			"title": "Werkervaring",
			"description": "Vertel ons waar je eerder hebt gewerkt, voor hoe lang en wat je daar deed. Heb je meerdere relevante banen gehad? Dan kun je die ook toevoegen.",
			"placeholder": "Beschrijf je eerdere werkervaring",
			"input_label": "Functiegegevens",
			"save": "Opslaan",
			"saving": "Bezig met opslaan…",
			"cancel": "Annuleren",
			"edit": "Bewerken",
			"remove": "Verwijderen",
			"add_another": "Nog een baan toevoegen",
			"error_empty": "Schrijf iets voordat je opslaat.",
			"error_limit": "Je kunt maximaal {{max}} banen toevoegen.",
			"unsaved_changes": "Je hebt niet-opgeslagen wijzigingen in je werkervaring. Wil je de pagina toch verlaten en deze wijzigingen kwijtraken?",
			"hints": {
				"label": "Gegevens over deze baan",
				"included": "vermeld",
				"missing": "nog niet vermeld"
			}
		},
		"education": {
			"title": "Opleiding",
			"description": "Vertel ons wat je hebt gestudeerd, waar en wanneer. Ook cursussen, diploma's en certificaten kun je hier toevoegen.",
			"placeholder": "Vertel ons over je opleidingen",
			"input_label": "Opleidingsgegevens",
			"save": "Opslaan",
			"saving": "Bezig met opslaan…",
			"cancel": "Annuleren",
			"edit": "Bewerken",
			"remove": "Verwijderen",
			"add_another": "Nog een opleiding toevoegen",
			"error_empty": "Schrijf iets voordat je opslaat.",
			"error_limit": "Je kunt maximaal {{max}} opleidingen toevoegen.",
			"unsaved_changes": "Je hebt niet-opgeslagen wijzigingen in je opleiding. Wil je de pagina toch verlaten en deze wijzigingen kwijtraken?"
		},
		"licenses": {
			"title": "Rijbewijzen en certificaten",
			"description": "Welke rijbewijzen of certificaten heb je? Vertel ons wanneer je ze hebt behaald en tot wanneer ze geldig zijn. Je kunt er meerdere toevoegen.",
			"placeholder": "Beschrijf je rijbewijzen en/of certificaten",
			"input_label": "Gegevens van het certificaat",
			"save": "Opslaan",
			"saving": "Bezig met opslaan…",
			"cancel": "Annuleren",
			"edit": "Bewerken",
			"remove": "Verwijderen",
			"add_another": "Nog een certificaat toevoegen",
			"error_empty": "Schrijf iets voordat je opslaat.",
			"error_limit": "Je kunt maximaal {{max}} certificaten toevoegen.",
			"unsaved_changes": "Je hebt niet-opgeslagen wijzigingen in je certificaten. Wil je de pagina toch verlaten en deze wijzigingen kwijtraken?"
		}
	},
	"submission": {
		"back": "Terug naar mijn reacties",
		"back_short": "Terug",
		"not_found": {
			"title": "Reactie niet gevonden",
			"body": "Deze reactie bestaat niet, of hoort niet bij jou."
		},
		"result": {
			"heading": "Resultaatscherm van je reactie"
		},
		"summary": {
			"title": "Jouw antwoorden",
			"submitted_on": "Je hebt dit formulier verzonden op",
			"submitted_more_than_once": "Je hebt dit formulier vaker dan één keer ingevuld. We voegen je profiel automatisch samen; hieronder zie je de meest recente inzending."
		}
	}
}
